<template>
  <div>
    <!-- API PARAMS FIELD -->
    <el-form label-width="100px">
      <p>Redact data on DB between these dates according to PII settings</p>

      <!-- DRY RUN -->
      <el-form-item label="Dry Run">
        <el-switch v-model="dryRun" />
      </el-form-item>
      <!-- DATE RANGE-->
      <el-form-item label="Date range">
        <el-date-picker
          v-model="datePicked"
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          format="dd/MM/yyyy"
          :default-time="['00:00:00', '23:59:59']"
          :disabled="loading"
        />
      </el-form-item>
      <!-- BUTTON -->
      <el-form-item>
        <el-button @click="redact" type="success" plain :loading="loading" :disabled="loading"
          >Start</el-button
        >
      </el-form-item>
    </el-form>

    <!-- RESULT JSON -->
    <el-dialog title="Result" :visible.sync="dialogVisible" width="700px">
      <JSONEditor ref="jsonEditor" v-model="results" />
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import JSONEditor from "@/components/JSONEditor";
import { gql } from "@apollo/client/core";
import { graph } from "@/store/api";

export default {
  components: { JSONEditor },
  data() {
    return {
      dryRun: true,
      datePicked: [moment().subtract(1, "days").toDate(), moment().toDate()],
      results: {},
      fetching: false,
      loading: false,
      dialogVisible: false,
    };
  },
  methods: {
    //
    async redact() {
      try {
        const confirmed = await this.$confirm(
          `Are you sure? This might take a couple minutes`,
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
          }
        );

        if (confirmed) {
          this.loading = true;

          const payload = {
            dateFrom: moment(this.datePicked[0]).toISOString(),
            dateTo: moment(this.datePicked[1]).toISOString(),
            dryRun: this.dryRun,
          };

          const response = await graph.mutate({
            mutation: gql`
              mutation ($data: JSON) {
                piiAPI {
                  redactDatabase(data: $data)
                }
              }
            `,
            variables: {
              data: payload,
            },
            fetchPolicy: "no-cache",
          });

          this.results = _.get(response, "data.piiAPI.redactDatabase", []);
          this.dialogVisible = true;

          this.$notify.success({
            title: "Success",
            message: "Redact finished",
            position: "bottom-right",
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify.error({
          title: "Error",
          message: _.toString(error),
          position: "bottom-right",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
